import React, { useContext } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useCheckoutProcessContext } from '../../contexts/CheckoutProcessContext';
import { InsetWrapper } from '../InsetWrapper';
import { Translation } from '../Translation';

const Name = props => {
    const { TranslationContext } = useCheckoutProcessContext();
    const translationContext = useContext(TranslationContext);

    const onNameChange = e => {
        props.onNameChange(e);
    }

    const onFocus = e => {
        if(props.onFocus) {
            props.onFocus(e, translationContext.t('checkout__full_name'));
        }
    }

    const showRequired = () => {
      return props.required;
    }

    return (
        <InsetWrapper hasError={!!props.error?.message}>
            <div className="input__top">
              <label
                id={`${props.id}-label`}
                className="input__label"
                htmlFor={props.id}
              >
                {translationContext.t("checkout__full_name")}
              </label>

              {showRequired() && <span
                className="input__required text__required">{translationContext.t('checkout__required')}</span>}
            </div>
            <input
              name="name"
              type="text"
              className="input__control"
              placeholder={translationContext.t('checkout__full_name')}
              value={props.name}
              onChange={onNameChange}
              required
              onFocus={onFocus}
              onBlur={props.onBlur}
              disabled={props.disabled}
              autoComplete='name'
              id={props.id}
              aria-invalid={!!props.error?.message}
              aria-describedby={`${props.id}-error`}
              aria-label={translationContext.t("checkout__full_name")}
              aria-required={showRequired()}
            />
            <p
              id={`${props.id}-error`}
              className={clsx("input--error__text", {
                "input--error__text--hidden": !props.error?.message
              })}
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              aria-describedby={`${props.id}-label`}
            >
              {props.error?.message && (
                <Translation interpolation={props.error?.interpolation}>
                    {props.error.message}
                </Translation>
              )}
            </p>
        </InsetWrapper>
    );
}

Name.propTypes = {
    name: PropTypes.string.isRequired,
    onNameChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
}

Name.defaultProps = {
    required: true
}

export default Name;
